module.exports = __webpack_public_path__ + "img/logo-icon.64645f35.jpeg";